import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

function Signup() {
  const [authError, setAuthError] = useState("");
  const [authLoading, setAuthLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const signup = async (username, password) => {
    setAuthLoading(true);
    setAuthError("");
    setSuccess(false);
    try {
    const apiUrl = process.env.REACT_APP_API_URL.replace(/\/+$/, ""); 

    const response = await fetch(`${apiUrl}/register`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    });

    console.log("Calling API URL:", `${apiUrl}/register`); 

    const contentType = response.headers.get("content-type");

      if (!response.ok) {
        let errorMessage = "Signup failed";
        if (contentType && contentType.includes("application/json")) {
          const errorData = await response.json();
          errorMessage = errorData.message || errorMessage;
        } else {
          const errorText = await response.text();
          errorMessage = errorText || errorMessage;
        }
        throw new Error(errorMessage);
      }

    const data = await response.json();
    setAuthLoading(false);
    if (data.message === "User registered") {
      setSuccess(true);
      setTimeout(() => navigate("/login"), 1500);
    } else {
      setAuthError(data.message || "Signup failed");
    }
      } catch (error) {
      setAuthError(error.message);
    } finally {
      setAuthLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-20 p-14 bg-blue-50 rounded-lg border border-blue-300">
      <h2 className="text-3xl font-extrabold mb-6 text-center text-blue-600">
        Sign Up
      </h2>
      {authError && (
        <div className="mb-3 text-center text-red-600 font-semibold">
          {authError}
        </div>
      )}
      {success && (
        <div className="mb-3 text-center text-green-600 font-semibold">
          Registration successful! Redirecting to login...
        </div>
      )}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          signup(username, password);
        }}
      >
        <input
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="p-3 border-2 border-blue-300 rounded w-full mb-3 focus:outline-none focus:ring-2 focus:ring-blue-400"
          placeholder="Username"
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="p-3 border-2 border-blue-300 rounded w-full mb-4 focus:outline-none focus:ring-2 focus:ring-blue-400"
          placeholder="Password"
        />
        <button
          type="submit"
          className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white font-bold rounded w-full transition-colors duration-200"
          disabled={authLoading}
        >
          {authLoading ? "Signing up..." : "Sign Up"}
        </button>
      </form>
      <div className="mt-5 text-center">
        <span className="text-gray-700">Already have an account? </span>
        <Link
          to="/login"
          className="text-blue-600 hover:underline font-semibold"
        >
          Login
        </Link>
      </div>
    </div>
  );
}

export default Signup;
